import {Simplex as BaseSimplex} from 'services/sports/default/simplex';
import Const from 'constants';
import ArrayHelper from 'helpers/array-helper';
import Action from 'actions';
import RuleBuilder from 'services/simplex/rule-builder';
import {addRoleSuffix, getSimplexUnitName} from 'helpers/simplex-helper';

export default class Simplex extends BaseSimplex {
    minTeams({incomingValues: {modes}}) {
        const state = Action.getState();
        const {preparedPlayers} = state.playersData;
        const teams = preparedPlayers.groupedBy.property('team');

        let constraints = [],
            minTeams = Number(state.sportConfig.getConfigProp('minTeams'));

        function createConstraintsForPlayersOfTeams(params) {
            const {teams, modes} = params;
            const constraints = {};
            Object.keys(teams).map((teamName) => {
                const builder = RuleBuilder.fromAtLeast(0);
                teams[teamName].map((player) => {
                    modes.map((mode) => {
                        const lpPlayerId = addRoleSuffix({
                            prefix: player.getId(),
                            role: mode,
                        });
                        builder.addVar(getSimplexUnitName(lpPlayerId), 1);
                    });
                });
                builder.addVar(Const.LP_TEAM_GROUP_PREFIX + teamName, -1);
                constraints[teamName] = builder;
            });
            return {...constraints};
        }

        const playersByTeamsConstraints = createConstraintsForPlayersOfTeams({
            teams,
            modes,
        });

        if (ArrayHelper.countItems(teams) >= minTeams) {
            let builder = RuleBuilder.fromAtLeast(minTeams);
            let generalObjective = {};
            Object.keys(playersByTeamsConstraints).map((teamName) => {
                builder.addVar(Const.LP_TEAM_GROUP_PREFIX + teamName, 1);
                generalObjective[Const.LP_TEAM_GROUP_PREFIX + teamName] = 0;
                constraints.push(playersByTeamsConstraints[teamName].createRule());
            });
            constraints.push(builder.createRule());

            this.store.patchObj('additionalObjective', {minTeams: {...generalObjective}});
        } else {
            Object.values(playersByTeamsConstraints).map((builder) => {
                builder.atLeast(1);
                constraints.push(builder.createRule());
            });
        }

        return [...constraints];
    }
}
